import { render, staticRenderFns } from "./TaskAdminListOrder.vue?vue&type=template&id=a64c4824&"
import script from "./TaskAdminListOrder.vue?vue&type=script&lang=js&"
export * from "./TaskAdminListOrder.vue?vue&type=script&lang=js&"
import style0 from "./TaskAdminListOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports